import { History, MapPin, Rocket } from "lucide-react";
import "../../styles/AssociationStory.css";

const AssociationStory = () => {
  return (
    <section className="story-section">
      <div className="story-container">
        <div className="story-header">
          <p className="story-kicker">Notre ancrage</p>
          <h2 className="story-title">Une identité locale, une méthode ouverte.</h2>
          <p className="story-subtitle">
            NMS06 conserve son origine solidaire tout en développant des outils
            plus clairs pour accompagner les démarches du quotidien.
          </p>
        </div>

        <div className="story-content">
          <div className="story-text">
            <h3>
              Pourquoi garder <span className="highlight-06">NMS06</span> ?
            </h3>
            <p>
              Le nom rappelle une histoire de terrain, de proximité et
              d'entraide. Cette identité reste importante : elle donne un cadre
              humain à des sujets souvent techniques ou difficiles.
            </p>
            <p>
              Le projet peut ensuite évoluer avec des outils numériques, sans
              perdre son objectif principal : aider les personnes à comprendre,
              formuler et défendre leurs demandes.
            </p>

            <div className="rebrand-box">
              <span className="old-meaning">Nice Moulins Solidarités</span>
              <span className="arrow">devient</span>
              <span className="new-meaning">Nouvelles Méthodes Solidaires</span>
            </div>

            <p className="story-conclusion">
              Le "06" reste une racine. La méthode, elle, peut servir toute
              personne qui cherche un accompagnement clair et accessible.
            </p>
          </div>

          <div className="story-timeline" aria-label="Évolution du projet">
            <div className="timeline-item">
              <div className="timeline-icon">
                <History size={19} />
              </div>
              <div className="timeline-content">
                <h4>Origine solidaire</h4>
                <p>
                  Une démarche née de besoins concrets : écoute, lien social et
                  entraide face aux difficultés du quotidien.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <MapPin size={19} />
              </div>
              <div className="timeline-content">
                <h4>Structuration des démarches</h4>
                <p>
                  Une organisation plus lisible pour préparer les courriers,
                  les dossiers, les échanges et les réclamations.
                </p>
              </div>
            </div>

            <div className="timeline-item active-step">
              <div className="timeline-icon">
                <Rocket size={19} />
              </div>
              <div className="timeline-content">
                <h4>Outils numériques et IA</h4>
                <p>
                  L'IA devient un appui de rédaction et de clarification, au
                  service d'un accompagnement qui reste humain.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssociationStory;
